import React from 'react'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import LeftInfoPanelList from './component/LeftInfoPanelList'

const LeftInfoPanel = () => {
    return (
        <JumboCardQuick wrapperSx={{ p: 0 }}>
            <LeftInfoPanelList />
        </JumboCardQuick>
    )
}

export default LeftInfoPanel
